import { AxiosRequestConfig } from "axios";
import mock from "../MockConfig";
import bannerData, {  transactionsData, userData ,locationData, centreData} from "@crema/services/db/master/masterData";

// Mock API to handle users
mock.onGet("/api/ecommerce/users").reply((request: AxiosRequestConfig) => {
  const { search, page } = request.params;

  let users = [...userData]; 

  if (search) {
    users = users.filter(
      (user) =>
        user.username.toLowerCase().includes(search.toLowerCase()) 
    );
  }

  return [
    200,
    {
      userCount: users.length,
      users: users.splice(page * 10, (page + 1) * 10), 
    },
  ];
});

// Mock API to handle fetching a single user by ID
mock.onGet("/api/ecommerce/user/get").reply((request: AxiosRequestConfig) => {
  const { id } = request.params;
  if (id >= 1 && id <= 10) {
    const data = userData.filter((item) => +item.id === +id); 
    if (data.length > 0) return [200, data[0]]; 
  }
  return [200, userData[0]]; 
});

// Mock API to handle banners (customers)
mock.onGet("/api/ecommerce/customers").reply((request: AxiosRequestConfig) => {
  const { search, page } = request.params;

  let banners = [...bannerData];

  if (search) {
    banners = banners.filter(
      (banner) =>
        banner.title.toLowerCase().includes(search.toLowerCase()) 
    );
  }

  return [
    200,
    {
      bannerCount: banners.length,
      banners: banners.splice(page * 10, (page + 1) * 10), 
    },
  ];
});

// Mock API to handle fetching a single banner by ID
mock.onGet("/api/ecommerce/get").reply((request: AxiosRequestConfig) => {
  const { id } = request.params;
  if (id >= 1 && id <= 10) {
    const data = bannerData.filter((item) => +item.id === +id); 
    if (data.length > 0) return [200, data[0]]; 
  }
  return [200, bannerData[0]]; 
});

// Mock API to handle fetching a list of transactions
mock.onGet("/api/ecommerce/transactions").reply((request: AxiosRequestConfig) => {
  const { search, page } = request.params;

  let transactions = [...transactionsData]; 

  if (search) {
    transactions = transactions.filter(
      (transaction) =>
        transaction.orderId.toLowerCase().includes(search.toLowerCase()) 
    );
  }

  return [
    200,
    {
      transactionCount: transactions.length,
      transactions: transactions, 
    },
  ];
});

// Mock API to handle fetching a single transaction by ID
mock.onGet("/api/ecommerce/transaction/get").reply((request: AxiosRequestConfig) => {
  const { id } = request.params;
  if (id >= 1 && id <= 10) {
    const data = transactionsData.filter((item) => +item.id === +id); 
    if (data.length > 0) return [200, data[0]]; 
  }
  return [200, transactionsData[0]]; 
});



// Mock API to handle fetching a list of polygon
// mock.onGet("/api/ecommerce/polygon").reply((request: AxiosRequestConfig) => {
//   const { search, page } = request.params;

//   let polygon = [...polygonData]; 

//   if (search) {
//     polygon = polygon.filter(
//       (polygon) =>
//         polygon.path.toLowerCase().includes(search.toLowerCase()) 
//     );
//   }

//   return [
//     200,
//     {
//       polygonCount: polygon.length,
//       polygon: polygon, 
//     },
//   ];
// });

// Mock API to handle fetching a single polygon by ID
// mock.onGet("/api/ecommerce/polygon/get").reply((request: AxiosRequestConfig) => {
//   const { id } = request.params;
//   if (id >= 1 && id <= 10) {
//     const data = polygonData.filter((item) => +item.id === +id); 
//     if (data.length > 0) return [200, data[0]]; 
//   }
//   return [200, polygonData[0]]; 
// });
// Mock API to handle fetching a list of locations
mock.onGet("/api/ecommerce/location").reply((request: AxiosRequestConfig) => {
  const { search, page } = request.params;
  let locations = [...locationData];

  if (search) {
    locations = locations.filter(
      (location) => location.sNo.toLowerCase().includes(search.toLowerCase())
    );
  }

  // Paginate results
  const startIndex = page * 10;
  const paginatedLocations = locations.slice(startIndex, startIndex + 10);

  return [
    200,
    {
      locationCount: locations.length,
      location: paginatedLocations,
    },
  ];
});

// Mock API to handle fetching a single location by ID
mock.onGet("/api/ecommerce/location/get").reply((request: AxiosRequestConfig) => {
  const { id } = request.params;
  const location = locationData.find((item) => +item.id === +id);

  if (location) {
    return [200, location];
  }

  return [404, { message: "Location not found" }];
});
// Mock API to handle centre
mock.onGet("/api/ecommerce/centre").reply((request: AxiosRequestConfig) => {
  const { search, page } = request.params;

  let centre = [...centreData]; 

  if (search) {
    centre = centre.filter(
      (centre) =>
        centre.categoryName.toLowerCase().includes(search.toLowerCase()) 
    );
  }

  return [
    200,
    {
      centreCount: centre.length,
      centre: centre.splice(page * 10, (page + 1) * 10), 
    },
  ];
});

// Mock API to handle fetching a single centre by sNo
mock.onGet("/api/ecommerce/centre/get").reply((request: AxiosRequestConfig) => {
  const { sNo } = request.params;
  if (sNo >= 1 && sNo <= 10) {
    const data = centreData.filter((item) => +item.sNo === +sNo); 
    if (data.length > 0) return [200, data[0]]; 
  }
  return [200, centreData[0]]; 
});
